// тестовые айдишники, чтобы было проще тестировать
export const LUGGAGE_FILTER_PANEL_CONTAINER_DATA_TEST_ID =
  'lt-luggage-filter-panel-container-data-test-id';
export const LUGGAGE_FILTER_PANEL_ELEMENT_DATA_TEST_ID =
  'lt-luggage-filter-panel-element-data-test-id';
